import React, { useState } from "react";
import axios from 'axios';
import AchievementDetailsModal from "./Modal/AchievementDetailsModal";
import useYearGameAchievementsFormatter from "../../utils/useYearGameAchievementsFormatter";

const API_PREFIX = `${location.origin}/api/v1/game`;

const CSSTransitionGroup = ({ children }) => {
    //todo: use transition group instead
    return children;
};

const TeamDetailsTablePerStage = ({team, stages, activeStage, game}) => {
    if (!stages) {
        return null;
    }

    const {formattedAchievements, setAchievements, formattedTypes, setTypes, fetchSingle} = useYearGameAchievementsFormatter(game.id);

    const [selectedSportman, setSelectedSportsman] = useState(null);
    const [selectedStage, setSelectedStage] = useState([]);

    const onStageDetailsClick = async (rankingClassificationId, sportsmanId, index) => {
        fetchSingle(rankingClassificationId, sportsmanId);

        let sportsmanIndex = team.mainSquad.findIndex(obj => obj.sportsmenId == parseInt(sportsmanId));
        setSelectedSportsman(team.mainSquad[sportsmanIndex].name);

        setSelectedStage(stages[index]['name']);
    }

    const onAchievementsDetailsClose = () => {
        setAchievements(null);
        setTypes([]);
    }

    return <table className="zw-tbl tbl-per-stage">
        <thead>
        <tr>{stages.map(
            stage => <th
                title={stage.name}
                key={stage.index}>
                {stage.index}
            </th>)}
        </tr>
        </thead>
        <Rows
            details={team.mainSquad}
            stages={stages}
            activeStage={activeStage}
            onClick={onStageDetailsClick}
        />
        <Rows
            skipTitle
            details={team.substitutes}
            stages={stages}
            activeStage={activeStage}
        />
        <Predictions
            predictions={team.predictions}
            teamTimeTrial={team.teamTimeTrial}
            columns={stages}
        />
        <TotalRow
            stagePoints={team.totalPerStage}
            stages={stages}
            activeStage={activeStage}
        />


        {/* Achievements Modal */}
        <CSSTransitionGroup
            transitionName="transition-fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          > 
            {formattedAchievements ? (
                <AchievementDetailsModal 
                  key="1" 
                  achievements={formattedTypes}
                  details={formattedAchievements} 
                  sportsman={selectedSportman}
                  game={game.name}
                  stage={selectedStage}
                  onClose={onAchievementsDetailsClose}
                />
            ) : null}
        </CSSTransitionGroup>
    </table>
};

const StagePoints = ({participates, points}) => participates ? points || 0 : '\u00A0';

const Predictions = ({predictions, teamTimeTrial, columns}) => {
    if (!predictions) {
        return null;
    }
    return <tbody>
    <NullRow title columns={columns}/>
    {predictions.map((prediction, i) => <NullRow key={i} columns={columns}/>)}
    {teamTimeTrial ? <NullRow columns={columns}/> : null}
    </tbody>
};

const NullRow = ({columns, title}) => {
    if (title) {
        return <tr>
            {columns.map((col, i)=><th key={i} dangerouslySetInnerHTML={{__html: '&nbsp;'}}/>)}
        </tr>
    }
    return <tr>
        {columns.map((col, i)=><td key={i} dangerouslySetInnerHTML={{__html: '&nbsp;'}}/>)}
    </tr>
};


const Rows = ({details, skipTitle, stages, activeStage, onClick = null}) => {
    if (!details) {
        return null
    }
    const ref = stages.findIndex(stage => stage.index == activeStage);
    return <tbody>
    {skipTitle && <NullRow title columns={stages}/> || null}
    {details.map(
        (detail, i)=> <tr key={i}>
            {detail.perStage.map(
                (stagePoints, j) => <StageDetail
                    key={j}
                    active={ ref === j}
                    stagePoints={stagePoints}
                    sportsmanId={detail.sportsmenId}
                    onClick={onClick}
                    index={j}
                />
            )}
        </tr>)}
    </tbody>;
};

const StageDetail =({active, stagePoints, sportsmanId, onClick, index}) => <td>
    <span className={ active && stagePoints.participates && stagePoints.points ? 'td-stage-list__col--active': ''}
        onClick={onClick ? () => onClick(stagePoints.superMatchId, sportsmanId, index) : undefined}
        style={{ cursor: 'pointer' }}
    >
        {StagePoints(stagePoints)}
    </span>
</td>;

const TotalRow = ({stagePoints, stages, activeStage}) => {

    const ref = stages.findIndex(stage => stage.index == activeStage);

    return stages && <tbody>
    <NullRow title columns={stages}/>
    <tr>{stagePoints.map((points, i) => <td key={i}><span className={ref === i ? 'td-stage-list__col--active' : ''}>{points.points}</span></td>)}
    </tr>
    <tr>{stagePoints.map((points, i) => <td key={i}><span className={ref === i ? 'td-stage-list__col--active' : ''}>{points.place}</span></td>)}
    </tr>
    </tbody> || null;
};

export default TeamDetailsTablePerStage;
